// theme.js
module.exports = {
    "token": {
      "colorPrimary": "#fa541c",
      "colorError": "#ff393d",
      "colorInfo": "#1782ff",
      // "colorBgBase": '#141414',
      // "cologrBgContainer": '#141414'
    }
  }